import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PhonicsAdvComponent } from '../phonics-adv/phonics-adv.component';
import { Student } from '../student-list/student';
import { StudentService } from '../_services/student.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from '../_helpers/roles';
@Component({
	selector: 'app-test-window',
	templateUrl: './test-window.component.html',
	styleUrls: ['./test-window.component.css'],
})
export class TestWindowComponent implements OnInit {
	private testSystemId: number = 1;
	selectedStudent: Subscription;
	activeStudent: Student;
	role: null;
	addScores = false;

	constructor(
		private modalService: NgbModal,
		private studentService: StudentService,
		private jwtHelper: JwtHelperService,
	) {}

	ngOnInit() {
		this.selectedStudent = this.studentService.selectedStudent$.subscribe(
			(data: Student) => {
				this.activeStudent = data;
			},
		);
	}

	openModal() {
		const modalRef = this.modalService.open(
			this.getComponentForTestSystem(this.testSystemId),
			{ size: 'xl' },
		);
		modalRef.componentInstance.name = 'currentTest';
	}

	getComponentForTestSystem(testSystemId) {
		if (testSystemId == 1) {
			return PhonicsAdvComponent;
		}
	}
}
